/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccPatientDataUploadErrorCategory } from './PccPatientDataUploadErrorCategory';
import {
    PccPatientDataUploadErrorCategoryFromJSON,
    PccPatientDataUploadErrorCategoryFromJSONTyped,
    PccPatientDataUploadErrorCategoryToJSON,
} from './PccPatientDataUploadErrorCategory';

/**
 * 
 * @export
 * @interface PccPatientDataUploadError
 */
export interface PccPatientDataUploadError {
    /**
     * 
     * @type {PccPatientDataUploadErrorCategory}
     * @memberof PccPatientDataUploadError
     */
    category: PccPatientDataUploadErrorCategory;
    /**
     * 
     * @type {string}
     * @memberof PccPatientDataUploadError
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PccPatientDataUploadError
     */
    additional_information?: string;
}

/**
 * Check if a given object implements the PccPatientDataUploadError interface.
 */
export function instanceOfPccPatientDataUploadError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;

    return isInstance;
}

export function PccPatientDataUploadErrorFromJSON(json: any): PccPatientDataUploadError {
    return PccPatientDataUploadErrorFromJSONTyped(json, false);
}

export function PccPatientDataUploadErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientDataUploadError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': PccPatientDataUploadErrorCategoryFromJSON(json['category']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'additional_information': !exists(json, 'additional_information') ? undefined : json['additional_information'],
    };
}

export function PccPatientDataUploadErrorToJSON(value?: PccPatientDataUploadError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': PccPatientDataUploadErrorCategoryToJSON(value.category),
        'id': value.id,
        'additional_information': value.additional_information,
    };
}

